import * as t from "react";
const o = /* @__PURE__ */ t.createContext(void 0);
function e() {
  return t.useContext(o);
}
export {
  o as F,
  e as u
};
//# sourceMappingURL=useFormControl-C9UMlaFq.mjs.map
